import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';

import { RootState } from 'store/store';

import { DataTransferAdminState } from '../types';
import { dataTransferAdminState } from './dataTransferAdminState';

export const dataTransferAdminSlice = createSlice({
  name: 'dataTransferAdmin',
  initialState: dataTransferAdminState,
  reducers: {
    setDataTransferLogs(
      state,
      action: PayloadAction<DataTransferAdminState['dataTransferLogs']>,
    ) {
      state.dataTransferLogs = action.payload;
    },
    setTotalRecordCounts: (state, action: PayloadAction<number>) => {
      state.totalRecordCount = action.payload < 0 ? 0 : action.payload;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
    },
    setPageIndex: (state, action: PayloadAction<number>) => {
      state.pageIndex = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setFromDate: (state, action: PayloadAction<string>) => {
      state.fromDate = action.payload;
    },
    setToDate: (state, action: PayloadAction<string>) => {
      state.toDate = action.payload;
    },
    setResetData: () => dataTransferAdminState,
  },
});

export const { actions: dataTransferAdminActions } = dataTransferAdminSlice;

export const selectDataTransferAdmin = (state: RootState) =>
  state.dataTransferAdmin;

export const selectDataTransferLogs = createSelector(
  selectDataTransferAdmin,
  state => state.dataTransferLogs,
);

export const selectTotalRecordCount = createSelector(
  selectDataTransferAdmin,
  state => state.totalRecordCount,
);

export const selectLimit = createSelector(
  selectDataTransferAdmin,
  state => state.limit,
);

export const selectPageIndex = createSelector(
  selectDataTransferAdmin,
  state => state.pageIndex,
);

export const selectSearch = createSelector(
  selectDataTransferAdmin,
  state => state.search,
);

export const selectFromDate = createSelector(
  selectDataTransferAdmin,
  state => state.fromDate,
);

export const selectToDate = createSelector(
  selectDataTransferAdmin,
  state => state.toDate,
);

export default dataTransferAdminSlice.reducer;
